import React, { useContext } from "react";
import { Calendar } from "phosphor-react";
import {
  StackAnalysisContext,
  StackAnalysisActions,
} from "context/stack_analysis";
import stackTileColored from "assets/images/StackTileColored.svg";
import biomassSrc from "assets/images/Biomass.svg";
import Button from "components/Button";
import TransactionWrapper from "components/templates/TransactionWrapper";
import PanelWrapper from "components/elements/Panel";
import "./index.scss";

const StackSeasonsSelection = () => {
  const { state, dispatch } = useContext(StackAnalysisContext);
  const years = ["2017", "2018", "2019", "2020", "2021", "2022", "2023"];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const { selectedYears, selectedMonth, selectedDates } = state;

  const toggleYear = (year) => {
    const newYears = selectedYears.includes(year)
      ? selectedYears.filter((prevYears) => prevYears !== year)
      : [...selectedYears, year];
    const newDates = selectedDates.some((item) => item.year === year)
      ? selectedDates.filter((item) => item.year !== year)
      : [...selectedDates, { year, date: null }];

    dispatch({
      type: StackAnalysisActions.SET_SELECTED_YEARS,
      value: [...newYears].sort(),
    });
    dispatch({
      type: StackAnalysisActions.SET_SELECTED_DATES,
      value: [...newDates],
    });
  };

  const selectMonth = (month) => {
    dispatch({
      type: StackAnalysisActions.SET_SELECTED_MONTH,
      value: month,
    });
  };

  const renderYearsSelection = () => {
    return (
      <>
        <div className="chip-container">
          {years.map((year) => (
            <button
              type="button"
              className={`button-chip ${
                selectedYears.includes(year) ? "-selected" : ""
              }`}
              key={year}
              onClick={() => toggleYear(year)}
            >
              {year}
            </button>
          ))}
        </div>
        <div className="stack-tiles">
          {selectedYears.map((year) => (
            <div className="tile" key={year}>
              <img src={stackTileColored} alt="alt" />
            </div>
          ))}
        </div>
      </>
    );
  };

  const renderMonthSelection = () => {
    return (
      <>
        <div className="chip-container">
          {months.map((month) => (
            <button
              type="button"
              className={`button-chip ${
                selectedMonth === month ? "-selected" : ""
              }`}
              key={month}
              onClick={() => selectMonth(month)}
            >
              {month}
            </button>
          ))}
        </div>
      </>
    );
  };

  return (
    <div className="stack-seasons-selection">
      <TransactionWrapper
        icon={<Calendar size={32} color="#339DFF" />}
        title="Specify seasons"
      >
        <PanelWrapper label="Select desired years for analysis. (minimum of 2 yrs.)">
          {renderYearsSelection()}
        </PanelWrapper>
        <PanelWrapper label="Select the month where the crop reaches its peak biomass">
          {renderMonthSelection()}
          <div className="biomass-container">
            <div className="biomass-wrapper">
              <div className="biomass-image">
                <img alt="alt" src={biomassSrc} />
              </div>
            </div>
          </div>
          <p className="details">
            The peak biomass will be used to select a number of captures so you
            can identify one which best represents the paddocks at their peak.
          </p>
        </PanelWrapper>
        <div className="page-action">
          <Button
            label="Back"
            color="white"
            rounded
            type="solid"
            block
            onClick={() =>
              dispatch({
                type: StackAnalysisActions.SET_PAGE,
                value: "fields",
              })
            }
          />
          <Button
            type="solid"
            label="Next"
            color="green"
            rounded
            block
            disabled={selectedYears.length <= 1}
            onClick={() =>
              dispatch({
                type: StackAnalysisActions.SET_PAGE,
                value: "captures",
              })
            }
          />
        </div>
      </TransactionWrapper>
    </div>
  );
};

export default StackSeasonsSelection;
